module.exports = __webpack_public_path__ + "img/physical_card.db27e5d4.svg";